module.exports = __webpack_public_path__ + "media/images/emblems/Ependes-coat_of_arms-8c17ca161b727f1a2b8e9c176ab28143.svg";